import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import SimpleConfigTable from "../shared/SimpleConfigTable";
import { feedbackResponsesApi, questionnairesApi } from "../../../../services/FeedbackServices";
import TablePagerBar from "../../TicketManagement/shared/TablePagerBar";

export default function ResponsesPanel() {
  const [rows, setRows] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionId, setQuestionId] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 });

  useEffect(() => {
    questionnairesApi("get")
      .then((res) => {
        const list = res?.data || [];
        setQuestions(list);
      })
      .catch(() => {
        setQuestions([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const params = questionId ? { questionnaire_id: questionId } : null;
    feedbackResponsesApi("get", params)
      .then((res) => {
        setRows(res?.data || []);
      })
      .catch(() => {
        setRows([]);
      });
  }, [questionId]);

  useEffect(() => {
    setPagination({ page: 1, perPage: 10 });
  }, [questionId, rows?.length]);

  const columns = useMemo(
    () => [
      { key: "questionnaire_name", label: "Questionnaire" },
      { key: "answer_type", label: "Answer Type" },
      { key: "selected_options", label: "Selected Options" },
      { key: "additional_feedback", label: "Additional Feedback" },
      { key: "submitted_at", label: "Submitted At" },
    ],
    []
  );

  const displayRows = useMemo(() => {
    return (rows || []).map((r) => ({
      ...r,
      selected_options: Array.isArray(r?.selected_options) ? r.selected_options.join(", ") : "-",
    }));
  }, [rows]);

  const pagedRows = useMemo(() => {
    const page = pagination.page || 1;
    const perPage = pagination.perPage || 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return (displayRows || []).slice(start, end);
  }, [displayRows, pagination.page, pagination.perPage]);

  return (
    <Box>
      <Box sx={{ mb: 2, maxWidth: 520 }}>
        <Autocomplete
          options={questions}
          value={questions.find((q) => String(q.id) === String(questionId)) || null}
          size={"small"}
          onChange={(e, next) => setQuestionId(next?.id || null)}
          getOptionLabel={(o) => o?.question || o?.name || ""}
          isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
          renderInput={(params) => <TextField {...params} label={"Filter by Question"} />}
          clearOnEscape
        />
      </Box>

      <SimpleConfigTable columns={columns} rows={pagedRows} onEdit={null} onLogicalDelete={null} />

      <TablePagerBar
        perPage={pagination.perPage}
        onPerPageChange={(e) => setPagination((p) => ({ ...p, perPage: Number(e.target.value), page: 1 }))}
        total={displayRows?.length || 0}
        page={pagination.page}
        onPageChange={(_, page) => setPagination((p) => ({ ...p, page }))}
      />
    </Box>
  );
}
